module.exports = __webpack_public_path__ + "static/media/contact-illustration-min.e6a6bb97.png";